<template>
  <div class="ticketReservation">
    <div class="nav_box">
      <div
        v-for="(item, index) in navs"
        :key="index"
        @click="onNav(item)"
        :style="{
          backgroundImage: 'url(' + item.imgUrl + ')',
        }"
      >
        {{ item.title }}
      </div>
    </div>
    <MyNotice ref="myNotice" @agree="agree" />
    <MyTips ref="myTips" :content="content" />
  </div>
</template>
<script>
import MyNotice from "@/components/MyNotice.vue";
import { getCommonConfig } from "@/api/Reservation";
import MyTips from "@/components/MyTips.vue";
import { config_get } from "@/api/MovieTicketReservation";
export default {
  name: "TicketReservation",
  data() {
    return {
      navs: [
        {
          title: "科技馆门票预约",
          content: "暂未开放科技馆门票预约",
          path: "/reservation",
          imgUrl: require(`@/assets/images/gate.png`),
          ticketType: 1,
        },
        {
          title: "儿童科学乐园门票预约",
          content: "暂未开放儿童科学乐园门票预约",
          path: "/reservation",
          imgUrl: require(`@/assets/images/children.png`),
          ticketType: 3,
        },
        {
          title: "4D影票购买",
          content: "暂未开放影票购买",
          path: "/shadowTicket",
          imgUrl: require(`@/assets/images/cinema.png`),
        },
        {
          title: "球幕影票购买",
          content: "暂未开放影票购买",
          path: "/shadowTicket",
          imgUrl: require(`@/assets/images/dome.png`),
        },
      ],
      content: "",
      data: {},
    };
  },
  components: { MyNotice, MyTips },
  created() {},
  mounted() {},
  methods: {
    async onNav(item) {
      if (
        item.title === "科技馆门票预约" ||
        item.title === "儿童科学乐园门票预约"
      ) {
        const { data } = await getCommonConfig({ ticketType: item.ticketType });
        if (data && data.isOpen) {
          this.data = item;
          this.$refs.myNotice.init(item.title, true, data.notice);
        } else {
          this.content = item.content;
          this.$refs.myTips.init();
        }
        // this.$refs.myNotice.init(item.title, true, "测试");
        // this.data = item;
      } else if (item.title === "4D影票购买" || item.title === "球幕影票购买") {
        const { data } = await config_get();
        if (data.channel === 1) {
          this.data = item;
          this.$refs.myNotice.init("影票购买", true, data.notice);
        } else {
          this.content = item.content;
          this.$refs.myTips.init();
        }
      } else {
        this.content = "暂未开启";
        this.$refs.myTips.init();
      }
    },
    agree() {
      let { path, title } = this.data;
      this.$router.push(path + "?type=" + title);
    },
  },
};
</script>
<style lang="scss" scoped>
.ticketReservation {
  .nav_box {
    padding: 20px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    > div {
      width: 332px;
      height: 73px;
      line-height: 73px;
      font-weight: 500;
      font-size: 16px;
      color: #ffffff;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      padding-left: 18px;
    }
    > div + div {
      margin-top: 10px;
    }
  }
}
</style>
